module.exports = __webpack_public_path__ + "static/img/akum_600_160.74d5490.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_160.svg
// module id = 6PT9
// module chunks = 1